// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xAk-","col":"styles_col__29qV5"};